import { render, staticRenderFns } from "./advantages.vue?vue&type=template&id=ceb06c10&scoped=true&"
import script from "./advantages.vue?vue&type=script&lang=js&"
export * from "./advantages.vue?vue&type=script&lang=js&"
import style0 from "./advantages.vue?vue&type=style&index=0&id=ceb06c10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb06c10",
  null
  
)

export default component.exports